import {LayoutCircleConfig, LayoutCircleType} from '../Layout/LayoutSection/Circles/LayoutSectionCircles.types';

const subscribeToOurNewsletterSectionCircles: LayoutCircleConfig = {
  desktop: [
    {
      type: LayoutCircleType.BLUE,
      style: {
        width: '3.3rem',
        top: '3.5rem',
        left: '0rem',
      },
    },
    {
      type: LayoutCircleType.LIGHT,
      style: {
        width: '9.2rem',
        top: '6.8rem',
        left: '-8rem',
      },
    },
    {
      type: LayoutCircleType.LIGHT,
      style: {
        width: '11.5rem',
        top: '31rem',
        right: '-9rem',
      },
    },
  ],
  tablet: [
    {
      type: LayoutCircleType.BLUE,
      style: {
        width: '3.3rem',
        top: '3.5rem',
        left: '0rem',
      },
    },
    {
      type: LayoutCircleType.LIGHT,
      style: {
        width: '9.2rem',
        top: '6.8rem',
        left: '-8rem',
      },
    },
    {
      type: LayoutCircleType.LIGHT,
      style: {
        width: '11.5rem',
        top: '31rem',
        right: '-9rem',
      },
    },
  ],
};

export default subscribeToOurNewsletterSectionCircles;
